import React, { ReactNode } from 'react';

type Props = {
    className?: string;
    title?: ReactNode;
    value?: ReactNode;
};

const Detail: React.FC<Props> = ({ className = '', title = '', value = '' }) => (
    <div className={`detail ${className}`}>
        <div className='title'>{title}</div>
        <div className='value'>{value}</div>
    </div>
);

export default Detail;
